import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSidebar } from "../../SidebarContext";
import Loader from "../Loader";
import { motion } from "framer-motion";
import {
    Clock,
    Calendar,
    MapPin,
    Briefcase,
    HeartPulse,
    Sparkles,
    Moon,
} from "lucide-react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

// Dummy Data
// const dummyEmployees = [
//     {
//         id: 1,
//         name: "Amit Sharma",
//         employeeId: "EMP001",
//         attendance: [
//             {
//                 date: "2025-08-01",
//                 checkIn: "2025-08-01T09:02:00",
//                 checkOut: "2025-08-01T17:00:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/32.jpg",
//             },
//             { date: "2025-08-02", leaveType: "weekOff" },
//             {
//                 date: "2025-08-03",
//                 checkIn: "2025-08-03T09:12:00",
//                 checkOut: "2025-08-03T16:58:00",
//                 checkInLocation: "Branch Office, Noida, 201301",
//                 checkOutLocation: "Branch Office, Noida, 201301",
//                 selfie: "https://randomuser.me/api/portraits/men/45.jpg",
//             },
//             {
//                 date: "2025-08-04",
//                 checkIn: "2025-08-04T08:55:00",
//                 checkOut: "2025-08-04T17:20:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/36.jpg",
//             },
//             { date: "2025-08-05", leaveType: "paid" },
//             {
//                 date: "2025-08-06",
//                 checkIn: "2025-08-06T09:10:00",
//                 checkOut: "2025-08-06T17:05:00",
//                 checkInLocation: "Branch Office, Noida, 201301",
//                 checkOutLocation: "Branch Office, Noida, 201301",
//                 selfie: "https://randomuser.me/api/portraits/men/50.jpg",
//             },
//             { date: "2025-08-07", leaveType: "sick" },
//             {
//                 date: "2025-08-08",
//                 checkIn: "2025-08-08T09:00:00",
//                 checkOut: "2025-08-08T16:55:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/60.jpg",
//             },
//             { date: "2025-08-09", leaveType: "festival" },
//             { date: "2025-08-10", leaveType: "weekOff" },
//             {
//                 date: "2025-08-11",
//                 checkIn: "2025-08-11T09:07:00",
//                 checkOut: "2025-08-11T17:03:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/70.jpg",
//             },
//             {
//                 date: "2025-08-12",
//                 checkIn: "2025-08-12T09:20:00",
//                 checkOut: "2025-08-12T16:50:00",
//                 checkInLocation: "Branch Office, Noida, 201301",
//                 checkOutLocation: "Branch Office, Noida, 201301",
//                 selfie: "https://randomuser.me/api/portraits/men/72.jpg",
//             },
//             { date: "2025-08-13", leaveType: "paid" },
//             {
//                 date: "2025-08-14",
//                 checkIn: "2025-08-14T08:59:00",
//                 checkOut: "2025-08-14T17:15:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/75.jpg",
//             },
//             { date: "2025-08-15", leaveType: "festival" },
//             {
//                 date: "2025-08-16",
//                 checkIn: "2025-08-16T09:05:00",
//                 checkOut: "2025-08-16T17:02:00",
//                 checkInLocation: "Branch Office, Noida, 201301",
//                 checkOutLocation: "Branch Office, Noida, 201301",
//                 selfie: "https://randomuser.me/api/portraits/men/77.jpg",
//             },
//             { date: "2025-08-17", leaveType: "weekOff" },
//             {
//                 date: "2025-08-18",
//                 checkIn: "2025-08-18T09:01:00",
//                 checkOut: "2025-08-18T16:59:00",
//                 checkInLocation: "Main Office, Delhi, 110001",
//                 checkOutLocation: "Main Office, Delhi, 110001",
//                 selfie: "https://randomuser.me/api/portraits/men/80.jpg",
//             },
//             {
//                 date: "2025-08-19",
//                 checkIn: "2025-08-19T09:14:00",
//                 checkOut: "2025-08-19T17:08:00",
//                 checkInLocation: "Branch Office, Noida, 201301",
//                 checkOutLocation: "Branch Office, Noida, 201301",
//                 selfie: "https://randomuser.me/api/portraits/men/82.jpg",
//             },
//             { date: "2025-08-20", leaveType: "sick" },
//         ],
//         leaves: {
//             paid: 3,
//             sick: 2,
//             festival: 2,
//         },
//     },
// ];

const shortAddress = (fullAddress) => {
  if (!fullAddress) return "";
  const parts = fullAddress.split(",");
  return parts.slice(1, 3).join(",").trim(); 
};

// Helpers
const formatTime = (dateTime) =>
    dateTime
        ? new Date(dateTime).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
        })
        : "—";

const averageTimeOfDay = (times) => {
    console.log(times)
    if (!times.length) return "—";

    // Convert each time string → minutes since midnight
    const minutesArray = times.map((t) => {
        const d = new Date(t);
        return d.getHours() * 60 + d.getMinutes();
    });

    // Average minutes
    const avgMinutes =
        minutesArray.reduce((acc, m) => acc + m, 0) / minutesArray.length;

    // Convert back → hours & minutes
    const hours = Math.floor(avgMinutes / 60);
    const minutes = Math.round(avgMinutes % 60);

    // Format nicely in AM/PM
    return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
    });
};


const formatNumber = (num) => num.toString().padStart(3, "0");

const StatCard = ({ title, value, gradient, icon: Icon }) => (
    <motion.div
        className={`relative min-w-[160px] rounded-2xl p-4 text-white shadow-lg ${gradient} overflow-hidden`}
    >
        <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-white/10 blur-xl" />
        <div className="absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-white/5 blur-lg" />
        <div className="relative z-10 text-center">
            {Icon && <Icon className="w-6 h-6 mx-auto mb-1 opacity-80" />}
            <h3 className="text-xs uppercase tracking-wide">{title}</h3>
            <p className="text-xl font-bold">{value}</p>
        </div>
    </motion.div>
);

const Tooltip = ({ text }) => (
    <div className="absolute z-50 top-full mt-1 right-0 w-max max-w-xs bg-gray-800 text-white text-xs rounded-md px-2 py-1 shadow-lg">
        {text}
    </div>
);

const EmployeeProfile = () => {
    
    const { id ,name} = useParams();
    const navigate = useNavigate();
    const [employee, setEmployee] = useState([]);
    const [load, setLoad] = useState(true);
    const [hovered, setHovered] = useState(null);
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""

    // useEffect(() => {
    //     const foundEmployee = employee.find(
    //         (emp) => emp.emplyee_ID === parseInt(id)
    //     );
    //     setEmployee(foundEmployee || null);
    //     setLoad(false);
    // }, [id]);


    const fetchEmployeeData = async () => {
        try {
            const response = await fetch(`${url}/staffattendance/singleassociate/${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            
            const mapped = res.data.map((d) => ({
                id: d.id,
                date: d.checkin_date ? new Date(d.checkin_date).toISOString().split("T")[0] : null,
                checkIn: d.checkin_date,
                checkOut: d.checkout_date,
                checkInLocation: d.checkin_location,
                checkOutLocation: d.checkout_location,
                selfie: d.selfie ? `${url}/${d.selfie.replace(/\\/g, "/")}` : null, // fix path
                leaveType: d.login_status !== "Present" ? d.login_status?.toLowerCase() : null, // optional
                checkInFrom: d.check_in_from,
                checkOutFrom: d.check_out_from,
                
            }));
            setEmployee(mapped);
        } catch (error) {
            console.error(error)
        } finally {
            setLoad(false)
        }
    }
    console.log(employee)

    useEffect(() => {
        fetchEmployeeData();
    }, [])


    if (load) return <Loader />;

    if (!employee) {
        return (
            <>
                <div className="bg-white p-6 rounded-xl shadow-lg text-center max-w-md mx-auto mt-10">
                    <h1 className="text-xl font-bold text-blue-700 mb-2">
                        Employee Not Found
                    </h1>
                    <button
                        onClick={() => navigate("/team-attendance")}
                        className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition"
                    >
                        Back to Team Attendance
                    </button>
                </div>
            </>
        );
    }

    const avgCheckIn = averageTimeOfDay(
        employee.filter((d) => d.checkIn).map((d) => d.checkIn)
    );
    const avgCheckOut = averageTimeOfDay(
        employee.filter((d) => d.checkOut).map((d) => d.checkOut)
    );

    return (
        <>
            <div className="max-w-6xl mx-auto">
                {/* Back + Title */}
                <div className="flex flex-row justify-between items-center gap-3 mb-4">
                    <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
                        {name} — Attendance
                    </h1>
                    <button
                        onClick={() => navigate("/team-attendance")}
                        className="px-4 py-1.5 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition"
                    >
                        Back
                    </button>
                </div>


                {/* Stats Row */}
                <div className="flex gap-4 overflow-x-auto py-3 no-scrollbar">
                    <StatCard
                        title="Avg Check-In"
                        value={avgCheckIn}
                        gradient="bg-gradient-to-r from-green-400 to-emerald-600"
                        icon={Clock}
                    />
                    <StatCard
                        title="Avg Check-Out"
                        value={avgCheckOut}
                        gradient="bg-gradient-to-r from-red-400 to-pink-600"
                        icon={Clock}
                    />
                    {/* <StatCard
                        title="Paid Leaves"
                        value={formatNumber(employee.leaves.paid)}
                        gradient="bg-gradient-to-r from-blue-400 to-indigo-600"
                        icon={Briefcase}
                    /> */}
                    {/* <StatCard
                        title="Sick Leaves"
                        value={formatNumber(employee.leaves.sick)}
                        gradient="bg-gradient-to-r from-yellow-400 to-orange-500"
                        icon={HeartPulse}
                    /> */}
                    {/* <StatCard
                        title="Festival Leaves"
                        value={formatNumber(employee.leaves.festival)}
                        gradient="bg-gradient-to-r from-purple-400 to-fuchsia-600"
                        icon={Sparkles}
                    /> */}
                </div>

                {/* Attendance Table */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    className="mt-3 bg-white rounded-xl shadow"
                >
                    <div className="p-4 border-b border-gray-100">
                        <h2 className="text-base font-semibold text-gray-700">
                            Daily Attendance
                        </h2>
                    </div>
                    <div className="divide-y divide-gray-100">
                        {employee.map((day, idx) => (
                            <div
                                key={idx}
                                className="flex flex-row md:items-center justify-between gap-4 px-4 py-3 text-sm relative"
                            >
                                {/* Date + Selfie / Icon */}
                                <div className="flex items-center gap-3">
                                    {day.leaveType ? (
                                        <>
                                            {day.leaveType === "paid" && (
                                                <Briefcase className="w-10 h-10 text-blue-600 border rounded-full p-2" />
                                            )}
                                            {day.leaveType === "sick" && (
                                                <HeartPulse className="w-10 h-10 text-orange-600 border rounded-full p-2" />
                                            )}
                                            {day.leaveType === "festival" && (
                                                <Sparkles className="w-10 h-10 text-purple-600 border rounded-full p-2" />
                                            )}
                                            {day.leaveType === "weekOff" && (
                                                <Moon className="w-10 h-10 text-gray-600 border rounded-full p-2" />
                                            )}
                                        </>
                                    ) : (
                                        day.selfie && (
                                            <img
                                                src={day.selfie}
                                                alt="selfie"
                                                className="w-10 h-10 rounded-full object-cover border"
                                            />
                                        )
                                    )}
                                    <div className="flex items-center gap-2">
                                        <Calendar className="w-4 h-4 text-gray-500" />
                                        <span className="text-gray-700 font-medium">
                                            {new Date(day.date).toLocaleDateString("en-US", {
                                                weekday: "short",
                                                day: "numeric",
                                                month: "short",
                                            })}
                                        </span>
                                    </div>
                                </div>

                                {/* Leave / Week Off */}
                                {day.leaveType ? (
                                    <div className="flex items-center gap-2 text-sm font-medium">
                                        {day.leaveType === "paid" && (
                                            <span className="text-blue-600 flex items-center gap-1">
                                                Paid Leave
                                            </span>
                                        )}
                                        {day.leaveType === "sick" && (
                                            <span className="text-orange-600 flex items-center gap-1">
                                                Sick Leave
                                            </span>
                                        )}
                                        {day.leaveType === "festival" && (
                                            <span className="text-purple-600 flex items-center gap-1">
                                                Festival Leave
                                            </span>
                                        )}
                                        {day.leaveType === "weekOff" && (
                                            <span className="text-gray-600 flex items-center gap-1">
                                                Week Off
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    /* Times + Locations */
                                    <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6 text-xs md:text-sm">
                                        <div className="flex items-center gap-1 text-green-600 relative">
                                            <Clock className="w-4 h-4" /> {formatTime(day.checkIn)}{", "}
                                            {day.checkInLocation && (
                                                <span
                                                    className="flex items-center text-gray-600 relative cursor-pointer gap-1"
                                                    onMouseEnter={() => setHovered(`in-${idx}`)}
                                                    onMouseLeave={() => setHovered(null)}
                                                >
                                                    <MapPin className="w-3 h-3" />{" "}
                                                    {shortAddress(day.checkInLocation)}
                                                    {hovered === `in-${idx}` && (
                                                        <Tooltip text={day.checkInLocation} />
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-1 text-red-600 relative">
                                            <Clock className="w-4 h-4" /> {formatTime(day.checkOut)}{", "}
                                            {day.checkOutLocation && (
                                                <span
                                                    className="flex items-center gap-1 text-gray-600 relative cursor-pointer"
                                                    onMouseEnter={() => setHovered(`out-${idx}`)}
                                                    onMouseLeave={() => setHovered(null)}
                                                >
                                                    <MapPin className="w-3 h-3" />{" "}
                                                    {shortAddress(day.checkOutLocation)}
                                                    {hovered === `out-${idx}` && (
                                                        <Tooltip text={day.checkOutLocation} />
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </>
    );
};

export default EmployeeProfile;
